export default __webpack_public_path__ + "static/media/C2_50_x_50.6f0118b5.jpg";